"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParameterConverter = void 0;
function isParameterConverter(node) {
    return "addParameterAsProperty" in node;
}
exports.isParameterConverter = isParameterConverter;
